package data.search_data

import models.SearchData

val PetraSearchSuggestions = listOf(
    "stamp",
    "canaanite",
    "figure",
    "membranophone",
    "seal",
    "copper",
    "molded",
    "brass",
    "dagger",
    "alloy",
    "silver",
    "slip",
    "animal",
    "stone",
    "sculpture",
    "opaque",
    "earthenware",
    "incised",
    "ink",
    "jambiya",
    "paper",
    "ceramics",
    "jasper",
    "metal",
    "unguentarium",
    "stonepaste",
    "ceramic",
    "leather",
    "green",
    "folio",
    "glazed",
    "sherd",
    "vessel",
    "white",
    "chordophone",
    "fragment",
    "book",
    "lute",
    "decoration",
    "headed",
    "female",
    "codices",
    "illustrated",
    "scaraboid",
    "drum",
    "shahnama",
    "jewelry",
    "bronze",
    "steatite",
    "porcelain",
    "plucked",
    "wood",
    "cultic",
    "kings",
    "painted",
    "gold",
    "watercolor",
    "quartz",
    "scarab",
    "steel",
    "manuscript",
    "daggers",
    "splash",
    "head",
    "sheath",
    "bowl",
    "scene",
)

// Machu Picchu (366)
val PetraSearchData = listOf(
    SearchData(
        -1630,
        324559,
        "Scarab seal",
        "stamp seal|stone, white|",
        "an/mobile-large/ss56_152_5.jpg",
        1.39
    ),
    SearchData(
        899,
        451503,
        "Fragment of a Bowl",
        "bowl fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-6b.jpg",
        1.22
    ),
    SearchData(50, 325916, "Plate", "plate|ceramic|", "an/mobile-large/ME67_246_35.jpg", 1.54),
    SearchData(
        -1450,
        328935,
        "Canaanite jar",
        "jar|ceramic|",
        "an/mobile-large/DP-16796-001.jpg",
        0.77
    ),
    SearchData(
        1850,
        31539,
        "Dagger (Jambiya) with Sheath",
        "dagger (jambiya) with sheath|steel, wood, brass, silver, gold, copper, brass wire|daggers",
        "aa/mobile-large/36.25.947ab_002july2014.jpg",
        0.67
    ),
    SearchData(
        849,
        451547,
        "Fragment",
        "fragment|earthenware; slip painted, glazed|ceramics",
        "is/mobile-large/sf60-23-52a.jpg",
        1.63
    ),
    SearchData(
        1750,
        31745,
        "Dagger (Jambiya)",
        "dagger (jambiya)|steel, wood, silver, copper, brass|daggers",
        "aa/mobile-large/36.25.765_001june2014.jpg",
        0.56
    ),
    SearchData(
        849,
        451535,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-39.jpg",
        0.76
    ),
    SearchData(-1500, 325125, "Adze head", "adze|bronze|", "an/mobile-large/ME61_73_2.jpg", 1.63),
    SearchData(
        1049,
        451602,
        "Fragment",
        "fragment|earthenware; incised and glazed|ceramics",
        "is/mobile-large/sf60-23-109a.jpg",
        0.81
    ),
    SearchData(
        899,
        451533,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-37a.jpg",
        1.60
    ),
    SearchData(
        1199,
        451513,
        "Fragment",
        "fragment|stonepaste; underglaze painted|ceramics",
        "is/mobile-large/sf60-23-16a.jpg",
        1.62
    ),
    SearchData(
        937,
        451509,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-12.jpg",
        1.26
    ),
    SearchData(
        1399,
        451554,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-59a.jpg",
        1.74
    ),
    SearchData(
        849,
        455152,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-25a.jpg",
        1.13
    ),
    SearchData(
        1849,
        443096,
        "Headband",
        "headband|silk, metal thread; wrapped and braided|textiles-costumes",
        "is/mobile-large/DP18737.jpg",
        0.40
    ),
    SearchData(
        1649,
        448587,
        "Panel from a Tent Lining (Qanat)",
        "panel|cotton; plain weave, mordant dyed and painted, resist-dyed|textiles-painted and/or printed",
        "is/mobile-large/DP212659.jpg",
        0.49
    ),
    SearchData(
        -650,
        321648,
        "Stamp seal (conoid) with cultic scene",
        "stamp seal|brown chalcedony (quartz), possibly etched to produce yellow mottling|",
        "an/mobile-large/ss86_11_28gp.jpg",
        1.01
    ),
    SearchData(-650, 326247, "Inlay", "inlay|bone|", "an/mobile-large/ME1977_234_16.jpg", 1.10),
    SearchData(
        899,
        451594,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-101.jpg",
        1.07
    ),
    SearchData(
        -650,
        327043,
        "Palette with a sculpted female head and incised decoration",
        "palette|calcite|",
        "an/mobile-large/vs1984_453_9.jpg",
        0.79
    ),
    SearchData(
        1525,
        446603,
        "\"Laila and Majnun in School\", Folio 129 from a Khamsa (Quintet) of Nizami of Ganja",
        "folio from an illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DT232547.jpg",
        0.62
    ),
    SearchData(
        1875,
        500993,
        "Stringed Instrument",
        "stringed instrument|turtle shell and wood, 4 strings.|chordophone-lute-plucked-fretted",
        "mi/mobile-large/midp89.4.371.jpg",
        1.60
    ),
    SearchData(
        -750,
        323748,
        "Stamp seal (scarab) with anthropomorphic figure",
        "stamp seal|mottled green glass|",
        "an/mobile-large/ss41_160_166.jpg",
        1.65
    ),
    SearchData(
        50,
        325899,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_18.jpg",
        0.71
    ),
    SearchData(
        -2500,
        325836,
        "Spouted vessel",
        "vessel|ceramic|",
        "an/mobile-large/ME66_183.jpg",
        1.35
    ),
    SearchData(
        -50,
        325075,
        "Fragment of a grave stele",
        "relief|alabaster (gypsum)|",
        "an/mobile-large/frieze.jpg",
        3.23
    ),
    SearchData(50, 325914, "Vessel", "vessel|ceramic|", "an/mobile-large/hb67_246_33.jpg", 1.94),
    SearchData(
        50,
        325897,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_16.jpg",
        0.71
    ),
    SearchData(
        1299,
        451584,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf-60-23-91b.jpg",
        1.66
    ),
    SearchData(
        849,
        451544,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-49a.jpg",
        1.35
    ),
    SearchData(
        -450,
        323936,
        "Stamp seal",
        "stamp seal|agate|",
        "an/mobile-large/ss41_160_661.jpg",
        1.42
    ),
    SearchData(50, 325892, "Cup", "cup|ceramic|", "an/mobile-large/ME67_246_11.jpg", 1.37),
    SearchData(
        -1630,
        324560,
        "Scarab seal",
        "stamp seal|steatite, white pink|",
        "an/mobile-large/ss56_152_6.jpg",
        0.72
    ),
    SearchData(
        1341,
        451414,
        "\"Siyavush Displays his Skill at Polo before Afrasiyab,\" Folio from a Shahnama (Book of Kings)",
        "folio from an illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/sf57-51-35r.jpg",
        0.83
    ),
    SearchData(50, 325883, "Small bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_2.jpg", 1.47),
    SearchData(
        -1630,
        326991,
        "Scarab seal",
        "stamp seal|faience, white (?)|",
        "an/mobile-large/ss1984_383_30.jpg",
        1.38
    ),
    SearchData(
        1200,
        451379,
        "Bowl with Courtly and Astrological Motifs",
        "bowl|stonepaste; polychrome inglaze and overglaze painted and gilded on opaque monochrome glaze (mina\"i)|ceramics",
        "is/mobile-large/DP170379.jpg",
        0.75
    ),
    SearchData(
        -750,
        323750,
        "Stamp seal (oval bezel) with cultic scene",
        "stamp seal|carnelian (quartz)|",
        "an/mobile-large/ss41_160_168.jpg",
        1.67
    ),
    SearchData(
        899,
        451590,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-97a.jpg",
        1.55
    ),
    SearchData(
        50,
        325891,
        "Male figurine",
        "sculpture|ceramic|",
        "an/mobile-large/ME67_246_10.jpg",
        0.78
    ),
    SearchData(
        1649,
        646829,
        "Filigree Casket with Sliding Top",
        "box|silver filigree; parcel-gilt|metal",
        "is/mobile-large/DP340529.jpg",
        0.78
    ),
    SearchData(
        1049,
        451599,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-106a.jpg",
        1.08
    ),
    SearchData(
        1675,
        24298,
        "Dagger with Sheath",
        "dagger with sheath|steel, nephrite, gold, rubies, emeralds, silver-gilt, leather|daggers",
        "aa/mobile-large/DP157696.jpg",
        0.73
    ),
    SearchData(
        -550,
        323933,
        "Stamp seal",
        "stamp seal|carnelian|",
        "an/mobile-large/ss41_160_560.jpg",
        1.88
    ),
    SearchData(
        899,
        451565,
        "Fragment",
        "fragment|stoneware|ceramics",
        "is/mobile-large/sf60-23-72b.jpg",
        2.02
    ),
    SearchData(
        1687,
        453279,
        "Calligraphic Plaque",
        "plaque|steel; forged and pierced|metal",
        "is/mobile-large/DP170397.jpg",
        1.71
    ),
    SearchData(
        -1597,
        544660,
        "Scarab with a Crocodile Headed Figure Holding a Flower",
        "scarab, crocodile figure, flower|glazed steatite|",
        "eg/mobile-large/M_398_bottom.jpg",
        0.78
    ),
    SearchData(
        1649,
        446546,
        "Shahnama (Book of Kings) of Firdausi",
        "illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP215296.jpg",
        0.70
    ),
    SearchData(
        -1673,
        324558,
        "Scarab seal",
        "stamp seal|stone, white|",
        "an/mobile-large/ss56_152_4.jpg",
        0.75
    ),
    SearchData(
        -750,
        324012,
        "Stamp seal (scarab) with animal",
        "stamp seal|hematite|",
        "an/mobile-large/ss45_4_18.jpg",
        0.75
    ),
    SearchData(
        -600,
        321633,
        "Stamp seal (scaraboid) with animal",
        "stamp seal|neutral chalcedony (quartz)|",
        "an/mobile-large/ss86_11_9gp.jpg",
        1.20
    ),
    SearchData(
        1399,
        451553,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-58a.jpg",
        1.60
    ),
    SearchData(
        899,
        451595,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-102a.jpg",
        1.44
    ),
    SearchData(50, 324247, "Sherd", "sherd|ceramic|", "an/mobile-large/ME52_129_4.jpg", 0.94),
    SearchData(50, 325902, "Cooking pot", "pot|ceramic|", "an/mobile-large/ME67_246_21.jpg", 1.13),
    SearchData(50, 324252, "Sherd", "sherd|ceramic|", "an/mobile-large/ME52_129_9.jpg", 1.64),
    SearchData(
        1540,
        452413,
        "Velvet Panel with Hunting Scene",
        "tent panel|silk, flat metal thread; cut and voided velvet|textiles",
        "is/mobile-large/DP267484.jpg",
        0.97
    ),
    SearchData(
        1399,
        451556,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-61a.jpg",
        1.55
    ),
    SearchData(
        1187,
        446860,
        "Luster Bowl with Winged Horse",
        "bowl|stonepaste; luster-painted on opaque monochrome glaze|ceramics",
        "is/mobile-large/DP212285.jpg",
        0.75
    ),
    SearchData(
        -600,
        323924,
        "Stamp seal (loaf-shaped hemispheroid) with animal",
        "stamp seal|banded carnelian (quartz)|",
        "an/mobile-large/seal1.jpg",
        1.42
    ),
    SearchData(0, 326243, "Open bowl", "bowl|ceramic, paint|", "an/mobile-large/DT904.jpg", 1.71),
    SearchData(
        1049,
        451606,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-113a.jpg",
        0.87
    ),
    SearchData(
        -1630,
        324567,
        "Scarab seal",
        "stamp seal|jasper, green (?)|",
        "an/mobile-large/ss56_152_13.jpg",
        0.66
    ),
    SearchData(
        1199,
        451564,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-71b.jpg",
        0.75
    ),
    SearchData(
        -850,
        326010,
        "Cylinder seal with chariot hunting scene",
        "cylinder seal|egyptian blue|",
        "an/mobile-large/SS1970_183_2.jpg",
        2.08
    ),
    SearchData(
        -1300,
        322598,
        "Enthroned deity",
        "sculpture|bronze, gold foil|",
        "an/mobile-large/hb32_18_3.jpg",
        0.53
    ),
    SearchData(50, 324250, "Sherd", "sherd|ceramic|", "an/mobile-large/ME52_129_7.jpg", 0.65),
    SearchData(
        1800,
        30999,
        "Sword (Saif) with Scabbard",
        "sword (saif) with scabbard|steel, silver, leather|swords",
        "aa/mobile-large/36.25.1547ab_001_Aug2015.jpg",
        1.50
    ),
    SearchData(
        787,
        327822,
        "Stamp seal",
        "stamp seal|sandstone or siltstone ?|",
        "an/mobile-large/vsz1999_325_226.jpg",
        1.11
    ),
    SearchData(
        1399,
        451555,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-60a.jpg",
        1.10
    ),
    SearchData(
        -1750,
        322913,
        "Nude female figure",
        "sculpture|ceramic|",
        "an/mobile-large/hb33_47_1.jpg",
        0.37
    ),
    SearchData(
        1199,
        451511,
        "Fragment",
        "fragment|stonepaste; underglaze painted|ceramics",
        "is/mobile-large/sf60-23-14a.jpg",
        2.14
    ),
    SearchData(
        1527,
        452142,
        "\"Kai Khusrau Rides Bihzad for the First Time\", Folio 212r from the Shahnama (Book of Kings) of Shah Tahmasp",
        "folio from an illustrated manuscript|opaque watercolor, ink, silver, and gold on paper|codices",
        "is/mobile-large/DP107149.jpg",
        0.68
    ),
    SearchData(
        1199,
        451558,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-63a.jpg",
        1.30
    ),
    SearchData(
        -750,
        326250,
        "Fragments of animal figurines",
        "sculpture|ceramic, paint|",
        "an/mobile-large/ME1977_234_19.jpg",
        1.55
    ),
    SearchData(
        849,
        451526,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-30a.jpg",
        1.36
    ),
    SearchData(
        899,
        451581,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-88b.jpg",
        0.88
    ),
    SearchData(
        50,
        324251,
        "Fragment of painted ware",
        "sherd|ceramic|",
        "an/mobile-large/ME52_129_8.jpg",
        0.88
    ),
    SearchData(50, 325915, "Cup", "cup|ceramic|", "an/mobile-large/ME67_246_34.jpg", 1.42),
    SearchData(
        1875,
        500988,
        "Naqqāra",
        "naqqāra|metal|membranophone-single-headed / kettle drum",
        "mi/mobile-large/midp89.4.366-368.jpg",
        1.65
    ),
    SearchData(50, 325918, "Vessel", "vessel|ceramic|", "an/mobile-large/hb67_246_37.jpg", 0.73),
    SearchData(
        -1630,
        324566,
        "Scaraboid seal",
        "stamp seal|rock crystal (?)|",
        "an/mobile-large/ss56_152_12.jpg",
        1.29
    ),
    SearchData(
        849,
        451520,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-23a.jpg",
        1.65
    ),
    SearchData(
        1892,
        32370,
        "Dagger (Jambiya) with Scabbard and Fitted Storage Case",
        "dagger (jambiya) with scabbard and fitted storage case|steel, silver, wood, textile, gold|daggers",
        "aa/mobile-large/DP157410.jpg",
        0.82
    ),
    SearchData(
        899,
        451500,
        "Fragment",
        "fragment|earthenware; unglazed|ceramics",
        "is/mobile-large/sf60-23-3a.jpg",
        0.80
    ),
    SearchData(
        -1500,
        323559,
        "Cylinder seal",
        "cylinder seal|stone|",
        "an/mobile-large/ss36_106_1.jpg",
        1.74
    ),
    SearchData(
        -750,
        322309,
        "Stamp seal (scaraboid) with cultic scene",
        "stamp seal|black limestone|",
        "an/mobile-large/ss99_22_40gp.jpg",
        0.83
    ),
    SearchData(
        899,
        451592,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-99a.jpg",
        1.63
    ),
    SearchData(
        -700,
        324013,
        "Stamp seal (scarab) with monster",
        "stamp seal|hematite|",
        "an/mobile-large/ss45_4_19.jpg",
        1.31
    ),
    SearchData(
        -1750,
        322916,
        "Nude female figure",
        "sculpture|ceramic|",
        "an/mobile-large/hb33_47_4.jpg",
        0.43
    ),
    SearchData(
        -750,
        326011,
        "Stamp seal (scarab) with monster",
        "stamp seal|lapis lazuli|",
        "an/mobile-large/ss1970_183_3.jpg",
        1.14
    ),
    SearchData(
        -1630,
        327099,
        "Scarab seal",
        "stamp seal|faience, white|",
        "an/mobile-large/ss1985_192_30.jpg",
        1.39
    ),
    SearchData(
        1449,
        451552,
        "Fragment",
        "fragment|stonepaste; slip and underglaze painted|ceramics",
        "is/mobile-large/sf60-23-57a.jpg",
        1.57
    ),
    SearchData(
        899,
        451576,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-83b.jpg",
        1.23
    ),
    SearchData(
        -1630,
        322528,
        "Elliptical ring bezel seal",
        "stamp seal|rock crystal|",
        "an/mobile-large/me23_10_9.jpg",
        1.40
    ),
    SearchData(
        1532,
        452170,
        "\"Bahrum Gur Before His Father, Yazdigird I\", Folio 551v from the Shahnama (Book of Kings) of Shah Tahmasp",
        "folio from an illustrated manuscript|opaque watercolor, ink, silver, and gold on paper|codices",
        "is/mobile-large/DP107205.jpg",
        0.67
    ),
    SearchData(
        1887,
        500569,
        "Gumuri",
        "gumuri|wood, parchment, hide|chordophone-lute-plucked-unfretted",
        "mi/mobile-large/MUS2027.jpg",
        0.23
    ),
    SearchData(
        1850,
        31773,
        "Dagger (Jambiya) with Sheath and Belt",
        "dagger (jambiya) with sheath and belt|steel, wood, gold, silver, textile, leather, brass|daggers",
        "aa/mobile-large/36.25.793ab_001July2014.jpg",
        1.50
    ),
    SearchData(
        1799,
        444633,
        "Powder Horn",
        "powder horn|brass and silver|arms and armor",
        "is/mobile-large/sf91-1-1082a.jpg",
        0.60
    ),
    SearchData(
        1800,
        30761,
        "Spear",
        "spear|steel, brass|shafted weapons",
        "aa/mobile-large/36.25.1949_001jan2015.jpg",
        0.56
    ),
    SearchData(
        899,
        451574,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-81b.jpg",
        1.24
    ),
    SearchData(
        50,
        325913,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_32.jpg",
        0.66
    ),
    SearchData(
        -1630,
        324561,
        "Scarab seal",
        "stamp seal|steatite, bone colored|",
        "an/mobile-large/ss56_152_7.jpg",
        0.78
    ),
    SearchData(
        -1750,
        322915,
        "Nude female figure",
        "sculpture|ceramic|",
        "an/mobile-large/me33_47_3.jpg",
        0.64
    ),
    SearchData(
        -750,
        321638,
        "Stamp seal (scaraboid) with animals",
        "stamp seal|variegated brown jasper (quartz)|",
        "an/mobile-large/ss86_11_14gp.jpg",
        0.87
    ),
    SearchData(
        1850,
        31703,
        "Dagger (Jambiya) with Sheath and Belt",
        "dagger (jambiya) with sheath and belt|steel, silver, wood, leather, iron|daggers",
        "aa/mobile-large/36.25.723ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        -750,
        327771,
        "Stamp seal (ovoid) with deity (?)",
        "stamp seal|steatite|",
        "an/mobile-large/vsz1999_325_175.jpg",
        0.85
    ),
    SearchData(
        1882,
        73632,
        "Mirror of National Costumes of All Nations  (Bankoku ishō kagami)",
        "print|triptych of woodblock prints (nishiki-e); ink and color on paper|prints",
        "as/mobile-large/DP148176.jpg",
        1.89
    ),
    SearchData(
        -125,
        327483,
        "Votive plaque inscribed with Sabaean dedication",
        "relief|copper alloy|",
        "an/mobile-large/DP368662.jpg",
        0.75
    ),
    SearchData(
        899,
        451588,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-95a.jpg",
        1.60
    ),
    SearchData(
        -500,
        324027,
        "Standing bull",
        "sculpture|bronze|",
        "an/mobile-large/DT895.jpg",
        0.85
    ),
    SearchData(
        150,
        324317,
        "Head-shaped flask",
        "flask|glass|",
        "an/mobile-large/ME54_101_2.jpg",
        0.74
    ),
    SearchData(
        -550,
        323747,
        "Scarab seal",
        "stamp seal|jasper, green|",
        "an/mobile-large/ss41_160_165.jpg",
        0.99
    ),
    SearchData(
        1299,
        451585,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf60-23-92a.jpg",
        0.73
    ),
    SearchData(
        999,
        451567,
        "Fragment",
        "fragment|celadon|ceramics",
        "is/mobile-large/sf60-23-74a.jpg",
        1.25
    ),
    SearchData(50, 325903, "Lamp", "lamp|ceramic|", "an/mobile-large/ME67_246_22.jpg", 1.46),
    SearchData(
        -1630,
        324555,
        "Scarab seal",
        "stamp seal|stone, white|",
        "an/mobile-large/ss56_152_1.jpg",
        0.74
    ),
    SearchData(
        -700,
        323163,
        "Nude female figure",
        "sculpture|ceramic|",
        "an/mobile-large/an34.126.53.jpg",
        0.66
    ),
    SearchData(
        1875,
        500981,
        "Junuk",
        "junuk|wood|chordophone-harp",
        "mi/mobile-large/Mus196A.jpg",
        0.65
    ),
    SearchData(
        937,
        451505,
        "Fragment of a Bowl",
        "fragment of a bowl|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-8.jpg",
        1.37
    ),
    SearchData(
        -700,
        326238,
        "Weight",
        "weight|hematite|",
        "an/mobile-large/ME1977_234_6.jpg",
        1.08
    ),
    SearchData(
        1149,
        451068,
        "Earring, One of a Pair",
        "earring|gold wire with filigree|jewelry",
        "is/mobile-large/LC-52_4_3.jpg",
        1.00
    ),
    SearchData(
        -500,
        326993,
        "Stamp seal (scaraboid) with cartouche",
        "stamp seal|limestone|",
        "an/mobile-large/ss1984_383_32.jpg",
        1.18
    ),
    SearchData(
        1556,
        444864,
        "Hawk Coin of the Emperor Akbar",
        "coin|gold|coins",
        "is/mobile-large/LC-99_35_7400.jpg",
        1.50
    ),
    SearchData(
        1199,
        449159,
        "Roundel with a Mounted Falconer and Hare",
        "roundel|gypsum plaster; modeled, painted, and gilded|sculpture",
        "is/mobile-large/DP373033.jpg",
        1.05
    ),
    SearchData(
        -1650,
        325690,
        "Seven-cup offering bowl",
        "bowl|ceramic|",
        "an/mobile-large/180468.jpg",
        1.25
    ),
    SearchData(
        50,
        325894,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_13.jpg",
        0.78
    ),
    SearchData(
        1199,
        451550,
        "Fragment",
        "fragment|stonepaste; slip painted, glazed|ceramics",
        "is/mobile-large/sf60-23-55a.jpg",
        1.05
    ),
    SearchData(
        -750,
        326997,
        "Stamp seal (scaraboid) with animal",
        "stamp seal|steatite, gray (?)|",
        "an/mobile-large/ss1984_383_36.jpg",
        0.94
    ),
    SearchData(
        -1800,
        330882,
        "Standing figure",
        "sculpture|copper alloy|",
        "an/mobile-large/2006_511.jpg",
        0.75
    ),
    SearchData(
        -1630,
        324562,
        "Scarab seal",
        "stamp seal|steatite, white|",
        "an/mobile-large/ss56_152_8.jpg",
        1.37
    ),
    SearchData(
        50,
        324248,
        "Fragment of painted ware",
        "sherd|ceramic|",
        "an/mobile-large/ME52_129_5.jpg",
        1.26
    ),
    SearchData(
        937,
        451504,
        "Fragment of a Bowl",
        "fragment of a bowl|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-7.jpg",
        1.24
    ),
    SearchData(
        849,
        451527,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-31a.jpg",
        1.06
    ),
    SearchData(
        -750,
        325519,
        "Head of bull",
        "sculpture|ceramic|",
        "an/mobile-large/ME62_116_2.jpg",
        0.91
    ),
    SearchData(50, 325889, "Bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_7.jpg", 1.42),
    SearchData(
        50,
        325909,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_28.jpg",
        0.65
    ),
    SearchData(
        1875,
        500962,
        "Darabukka",
        "darabukka|clay, polychrome|membranophone-single-headed / goblet drum",
        "mi/mobile-large/C2589 89.4.335.jpg",
        0.67
    ),
    SearchData(
        899,
        451596,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-103.jpg",
        1.09
    ),
    SearchData(
        -700,
        326255,
        "Arrowhead",
        "arrowhead|bronze|",
        "an/mobile-large/ME1977_234_24.jpg",
        0.80
    ),
    SearchData(
        -750,
        326995,
        "Stamp seal (scaraboid) with divine symbol",
        "stamp seal|limestone (?)|",
        "an/mobile-large/ss1984_383_34.jpg",
        1.07
    ),
    SearchData(
        1299,
        451582,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf60-23-89a.jpg",
        0.94
    ),
    SearchData(
        849,
        451518,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-21a.jpg",
        1.11
    ),
    SearchData(
        899,
        451498,
        "Fragment of a Cup",
        "fragment of a cup|earthenware; unglazed|ceramics",
        "is/mobile-large/sf60-23-1a.jpg",
        1.35
    ),
    SearchData(
        -700,
        323823,
        "Stamp seal (duck-shaped) with cultic scene",
        "stamp seal|variegated pink and white chalcedony (quartz)|",
        "an/mobile-large/ss41_160_232.jpg",
        1.55
    ),
    SearchData(
        1887,
        500570,
        "Guenbri",
        "gunibri|tortoise shell and wood.  floral design in white, yellow, and pink.|chordophone-lute-plucked-unfretted",
        "mi/mobile-large/MUS2015.jpg",
        0.27
    ),
    SearchData(
        899,
        451589,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-96a.jpg",
        0.89
    ),
    SearchData(
        937,
        451508,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-11a.jpg",
        1.81
    ),
    SearchData(50, 325890, "Bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_9.jpg", 1.40),
    SearchData(
        899,
        451578,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-85a.jpg",
        1.47
    ),
    SearchData(
        -662,
        323177,
        "Jar handle with a seal impression",
        "jar handle|ceramic|",
        "an/mobile-large/DP-16934-003.jpg",
        1.43
    ),
    SearchData(
        849,
        451529,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-33a.jpg",
        1.24
    ),
    SearchData(
        -750,
        322302,
        "Stamp seal (scaraboid) with geometric design",
        "stamp seal|steatite, black|",
        "an/mobile-large/ss99_22_33gp.jpg",
        0.72
    ),
    SearchData(
        -750,
        322307,
        "Stamp seal (scaraboid) with cultic banquet scene",
        "stamp seal|mottled orange jasper (quartz)|",
        "an/mobile-large/ss99_22_38gp.jpg",
        1.19
    ),
    SearchData(
        -1630,
        324565,
        "Scarab seal ring with Hyksos-period an-ra inscription",
        "stamp seal ring|steatite, cream colored, bronze (?)|",
        "an/mobile-large/ss56_152_11.jpg",
        0.95
    ),
    SearchData(
        -500,
        323745,
        "Scarab seal with Bes dominating two lions below a winged sun disc",
        "stamp seal|jasper, green|",
        "an/mobile-large/ss41_160_163.jpg",
        1.74
    ),
    SearchData(
        -2000,
        327544,
        "Standing female figure wearing a strap and a necklace",
        "sculpture|sandstone, quartzite|",
        "an/mobile-large/DT868.jpg",
        0.76
    ),
    SearchData(
        937,
        451506,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-9.jpg",
        1.52
    ),
    SearchData(
        -1875,
        322521,
        "Fenestrated axe blade",
        "axe|bronze|",
        "an/mobile-large/hb23_10_2.jpg",
        0.89
    ),
    SearchData(
        899,
        451501,
        "Fragment",
        "fragment|earthenware; unglazed|ceramics",
        "is/mobile-large/sf60-23-4a.jpg",
        0.92
    ),
    SearchData(
        899,
        451531,
        "Fragment",
        "fragment|earthenware; incised decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-35a.jpg",
        0.95
    ),
    SearchData(
        799,
        451571,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-78b.jpg",
        1.48
    ),
    SearchData(
        1299,
        451583,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf60-23-90a.jpg",
        1.30
    ),
    SearchData(
        -2323,
        544034,
        "Head of a monkey from an ointment vessel",
        "ointment jar fragment, monkey head|serpentinite|",
        "eg/mobile-large/1970.184.3_EGDP010831.jpg",
        1.02
    ),
    SearchData(
        899,
        451591,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-98a.jpg",
        1.00
    ),
    SearchData(50, 325919, "Lamp", "lamp|ceramic|", "an/mobile-large/ME67_246_38.jpg", 1.42),
    SearchData(
        1489,
        30812,
        "Axe (Berdiche)",
        "axe (berdiche)|steel, wood, silver|shafted weapons",
        "aa/mobile-large/DP165529.jpg",
        0.68
    ),
    SearchData(
        849,
        451563,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-70a.jpg",
        1.08
    ),
    SearchData(
        1199,
        451510,
        "Fragment",
        "fragment|stonepaste; underglaze painted|ceramics",
        "is/mobile-large/sf60-23-13a.jpg",
        1.23
    ),
    SearchData(
        11,
        442859,
        "Basket Earring",
        "earring|gold, silver (?); decorated with filigree and granulation|jewelry",
        "is/mobile-large/74.51.3607.jpg",
        1.08
    ),
    SearchData(
        899,
        451537,
        "Fragment",
        "fragment|earthenware; splash glazed decoration|ceramics",
        "is/mobile-large/60-23-41.jpg",
        1.67
    ),
    SearchData(50, 325907, "Bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_26.jpg", 1.34),
    SearchData(
        849,
        451561,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-66a.jpg",
        1.01
    ),
    SearchData(
        1099,
        451566,
        "Fragment",
        "fragment|celadon|ceramics",
        "is/mobile-large/sf60-23-73a.jpg",
        0.88
    ),
    SearchData(
        1124,
        446283,
        "Ewer with Molded Inscriptions and Figures on Horseback",
        "ewer|stonepaste; molded, monochrome glazed|ceramics",
        "is/mobile-large/LC-13_93_3.jpg",
        0.67
    ),
    SearchData(
        1149,
        451069,
        "Earring, One of a Pair",
        "earring|gold wire with filigree|jewelry",
        "is/mobile-large/52.4.3-4.jpg",
        0.70
    ),
    SearchData(
        -700,
        326252,
        "Fragment of animal figurine",
        "sculpture|ceramic|",
        "an/mobile-large/ME1977_234_21.jpg",
        0.87
    ),
    SearchData(
        -2500,
        327596,
        "Rectangular mortar",
        "mortar|veined marble|",
        "an/mobile-large/vs1999_324.jpg",
        1.08
    ),
    SearchData(
        -1600,
        556377,
        "Canaanite Cowroid Seal Amulet with Falcon Headed Deity",
        "cowroid seal amulet, falcon headed deity|steatite|",
        "eg/mobile-large/05.3.32_bottom.jpg",
        1.07
    ),
    SearchData(50, 325884, "Bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_3.jpg", 1.27),
    SearchData(-1500, 325126, "Staff (?)", "staff|bronze|", "an/mobile-large/ME61_73_3.jpg", 0.56),
    SearchData(
        849,
        451543,
        "Fragment",
        "fragment|earthenware; splash glazed|ceramics",
        "is/mobile-large/sf60-23-48a.jpg",
        1.44
    ),
    SearchData(50, 324249, "Sherd", "sherd|ceramic|", "an/mobile-large/ME52_129_6.jpg", 0.94),
    SearchData(
        899,
        451499,
        "Fragment",
        "fragment|earthenware; unglazed|ceramics",
        "is/mobile-large/sf60-23-2a.jpg",
        1.07
    ),
    SearchData(
        899,
        451539,
        "Fragment",
        "fragment|earthenware; painted splash glazed decoration|ceramics",
        "is/mobile-large/sf60-23-43.jpg",
        1.19
    ),
    SearchData(
        -250,
        328941,
        "Standing bull",
        "sculpture|copper alloy, shell|",
        "an/mobile-large/2002.34.jpg",
        0.79
    ),
    SearchData(50, 325917, "Bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_36.jpg", 1.39),
    SearchData(
        999,
        455153,
        "Fragment",
        "fragment|earthenware; luster-painted|ceramics",
        "is/mobile-large/sf60-23-46a.jpg",
        1.24
    ),
    SearchData(
        849,
        451560,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-65a.jpg",
        1.35
    ),
    SearchData(
        849,
        455173,
        "Fragment",
        "fragment|earthenware; painted and glazed|ceramics",
        "is/mobile-large/sf60-23-68a.jpg",
        1.64
    ),
    SearchData(
        1849,
        444669,
        "Necklace",
        "necklace|silver and cloth|jewelry",
        "is/mobile-large/LC-91_1_1132.jpg",
        1.50
    ),
    SearchData(
        849,
        451530,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-34a.jpg",
        1.07
    ),
    SearchData(
        1875,
        500989,
        "Naqqareh",
        "naqqareh|wood|membranophone-single-headed / kettle drum",
        "mi/mobile-large/C2589 89.4.367.jpg",
        1.50
    ),
    SearchData(
        50,
        325910,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_29.jpg",
        0.65
    ),
    SearchData(
        937,
        451507,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-10a.jpg",
        0.85
    ),
    SearchData(
        849,
        451568,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-75a.jpg",
        1.00
    ),
    SearchData(
        -1892,
        322525,
        "Fish amulet",
        "amulet|stone|",
        "an/mobile-large/me23_10_6.jpg",
        1.38
    ),
    SearchData(
        899,
        451532,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-36a.jpg",
        1.44
    ),
    SearchData(
        -125,
        326695,
        "Standing male figure",
        "sculpture|alabaster (gypsum)|",
        "an/mobile-large/an1982.317.3.jpg",
        0.72
    ),
    SearchData(50, 325901, "Lamp", "lamp|ceramic|", "an/mobile-large/ME67_246_20.jpg", 1.57),
    SearchData(
        849,
        451528,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-32a.jpg",
        1.53
    ),
    SearchData(
        1849,
        817059,
        "Tapis, ceremonial skirt with squid pattern (cumi-cumi) iconography",
        "ceremonial skirt (tapis)|cotton, silk, mica, dyes|textiles-costumes",
        "ao/mobile-large/Squid_textile_Confino.jpg",
        1.28
    ),
    SearchData(
        899,
        451577,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-84a.jpg",
        0.98
    ),
    SearchData(
        1049,
        452939,
        "Pair of Earrings",
        "earrings|gold; filigree and granulation|jewelry",
        "is/mobile-large/DP233260.jpg",
        1.34
    ),
    SearchData(
        1875,
        500990,
        "Naqqāra",
        "naqqāra|metal|membranophone-single-headed / kettle drum",
        "mi/mobile-large/MUS687A1.jpg",
        1.03
    ),
    SearchData(
        -1875,
        325093,
        "Fenestrated axe blade",
        "axe|bronze|",
        "an/mobile-large/HB61_29.jpg",
        1.81
    ),
    SearchData(50, 325886, "Juglet", "juglet|ceramic|", "an/mobile-large/ME67_246_5.jpg", 0.78),
    SearchData(
        50,
        325908,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_27.jpg",
        0.63
    ),
    SearchData(
        849,
        451522,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-26a.jpg",
        1.19
    ),
    SearchData(
        1875,
        500998,
        "Kamānja agūz (old fiddle)",
        "kamānja agūz (old fiddle)|wood,  coconut shell, skin|chordophone-lute-bowed-unfretted",
        "mi/mobile-large/MUS195Aright.jpg",
        0.23
    ),
    SearchData(
        1602,
        453336,
        "A Stallion",
        "illustrated  album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP234078.jpg",
        1.48
    ),
    SearchData(
        -1750,
        322914,
        "Nude female figure",
        "sculpture|ceramic|",
        "an/mobile-large/me33_47_2.jpg",
        0.54
    ),
    SearchData(
        899,
        451540,
        "Fragment",
        "fragment|earthenware|ceramics",
        "is/mobile-large/sf60-23-44ab.jpg",
        1.81
    ),
    SearchData(
        1315,
        451412,
        "\"Yazdegird I Kicked to Death by the Water Horse\", Folio from a Shahnama (Book of Kings)",
        "folio from an illustrated manuscript|ink, opaque watercolor, silver, and gold on paper|codices",
        "is/mobile-large/DP159355.jpg",
        0.79
    ),
    SearchData(
        1399,
        451557,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-62a.jpg",
        1.28
    ),
    SearchData(
        1800,
        31772,
        "Dagger (Jambiya) with Sheath",
        "dagger (jambiya) with sheath|steel, brass, wood, textile|daggers",
        "aa/mobile-large/36.25.792ab_001Mar2015.jpg",
        0.71
    ),
    SearchData(
        849,
        451521,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-24a.jpg",
        1.36
    ),
    SearchData(-1892, 322526, "Pendant", "pendant|stone|", "an/mobile-large/me23_10_7.jpg", 0.91),
    SearchData(
        -500,
        324075,
        "Incense burner",
        "incense burner|bronze|",
        "an/mobile-large/DT893.jpg",
        0.88
    ),
    SearchData(
        899,
        451538,
        "Fragment",
        "fragment|earthenware; splash glazed decoration|ceramics",
        "is/mobile-large/sf60-23-42.jpg",
        1.08
    ),
    SearchData(50, 324246, "Sherd", "sherd|ceramic|", "an/mobile-large/ME52_129_3.jpg", 1.64),
    SearchData(
        -750,
        326998,
        "Stamp seal (scarab) with animal",
        "stamp seal|mottled greenstone|",
        "an/mobile-large/ss1984_383_37.jpg",
        1.13
    ),
    SearchData(
        1149,
        450930,
        "Jar",
        "jar|earthenware; glazed|ceramics",
        "is/mobile-large/LC-48_113_2.jpg",
        0.80
    ),
    SearchData(
        849,
        451515,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-18a.jpg",
        1.24
    ),
    SearchData(50, 325906, "Juglet", "juglet|ceramic|", "an/mobile-large/ME67_246_25.jpg", 0.79),
    SearchData(
        50,
        325896,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_15.jpg",
        0.73
    ),
    SearchData(
        -500,
        323925,
        "Scarab seal with human head",
        "stamp seal|stone, mottled red and white|",
        "an/mobile-large/ss41_160_459.jpg",
        1.51
    ),
    SearchData(
        1049,
        451603,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-110a.jpg",
        1.19
    ),
    SearchData(
        1049,
        451605,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-112a.jpg",
        0.87
    ),
    SearchData(50, 325905, "Vessel", "vessel|ceramic|", "an/mobile-large/ME67_246_24.jpg", 0.80),
    SearchData(
        849,
        451542,
        "Fragment",
        "fragment|earthenware; splash glazed|ceramics",
        "is/mobile-large/sf60-23-47a.jpg",
        1.18
    ),
    SearchData(
        1875,
        501012,
        "Daff",
        "daff|wood and parchment.|membranophone-double-headed / frame drum",
        "mi/mobile-large/midp89.4.392.jpg",
        1.78
    ),
    SearchData(
        50,
        325911,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_30.jpg",
        0.72
    ),
    SearchData(50, 325882, "Small bowl", "bowl|ceramic|", "an/mobile-large/ME67_246_1.jpg", 1.47),
    SearchData(
        -750,
        322308,
        "Stamp seal (scaraboid) with cultic scene",
        "stamp seal|green-black serpentine|",
        "an/mobile-large/ss99_22_39gp.jpg",
        0.85
    ),
    SearchData(
        899,
        451579,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-86b.jpg",
        0.94
    ),
    SearchData(
        849,
        451562,
        "Fragment",
        "fragment|earthenware; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-67a.jpg",
        1.60
    ),
    SearchData(-1892, 322522, "Pin", "pin|bronze|", "an/mobile-large/me23_10_3.jpg", 1.78),
    SearchData(
        50,
        324245,
        "Fragment of painted ware",
        "sherd|ceramic|",
        "an/mobile-large/ME52_129_2.jpg",
        1.29
    ),
    SearchData(
        1199,
        451570,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-77a.jpg",
        1.13
    ),
    SearchData(
        1849,
        503640,
        "Daraboukkeh",
        "daraboukkeh|pottery|membranophone-single-headed / goblet drum",
        "mi/mobile-large/C2589 89.4.364.jpg",
        0.67
    ),
    SearchData(
        -1300,
        327319,
        "Smiting weather god or warrior with horned headgear",
        "sculpture|bronze|",
        "an/mobile-large/242307.jpg",
        0.80
    ),
    SearchData(
        -300,
        329093,
        "Figure of a lion",
        "sculpture|copper alloy|",
        "an/mobile-large/DT2856.jpg",
        1.26
    ),
    SearchData(
        -750,
        326251,
        "Fragment of animal figurine",
        "sculpture|ceramic|",
        "an/mobile-large/ME1977_234_20.jpg",
        0.83
    ),
    SearchData(
        1875,
        500984,
        "Stringed Instrument (Qanbus)",
        "stringed instrument (qanbus)|wood, hide|chordophone-lute-plucked-fretted",
        "mi/mobile-large/Mus214A middle.jpg",
        0.73
    ),
    SearchData(
        -1600,
        544670,
        "Canaanite Scarab with a Lion over a Crocodile",
        "scarab, lion, crocodile|steatite|",
        "eg/mobile-large/D_767_bottom.jpg",
        1.18
    ),
    SearchData(
        50,
        325885,
        "Ribbed juglet",
        "juglet|ceramic|",
        "an/mobile-large/hb67_246_4.jpg",
        0.83
    ),
    SearchData(
        -1892,
        322523,
        "Bracelet",
        "bracelet|bronze|",
        "an/mobile-large/me23_10_4.jpg",
        1.22
    ),
    SearchData(
        50,
        325895,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_14.jpg",
        0.70
    ),
    SearchData(
        1049,
        451601,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-108a.jpg",
        1.34
    ),
    SearchData(
        -650,
        326240,
        "Cosmetic palette",
        "cosmetic palette|stone|",
        "an/mobile-large/ME1977_234_9.jpg",
        1.64
    ),
    SearchData(
        -1888,
        322527,
        "Hemispheroid seal with addorsed Egyptianizing human heads",
        "stamp seal|steatite, white|",
        "an/mobile-large/ss23_10_8a.jpg",
        1.49
    ),
    SearchData(
        -550,
        323941,
        "Scarab seal",
        "stamp seal|rock crystal|",
        "an/mobile-large/ss42_8.jpg",
        0.81
    ),
    SearchData(
        -500,
        327499,
        "Vessel with a lid",
        "vessel and lid|calcite alabaster|",
        "an/mobile-large/jarxx.jpg",
        0.76
    ),
    SearchData(
        1887,
        500568,
        "Guenbri",
        "guenbri|gourd, wood, parchment decorated with floral designs|chordophone-lute-plucked-unfretted",
        "mi/mobile-large/MUS2014.jpg",
        0.29
    ),
    SearchData(
        849,
        451516,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-19a.jpg",
        1.22
    ),
    SearchData(50, 325887, "Small lamp", "lamp|ceramic|", "an/mobile-large/ME67_246_6.jpg", 1.54),
    SearchData(
        -1648,
        544664,
        "Canaanite Scarab with Two Men and a Lion",
        "scarab, men, lion|steatite (glazed)|",
        "eg/mobile-large/D_764_bottom.jpg",
        1.46
    ),
    SearchData(
        1049,
        451607,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-114a.jpg",
        1.20
    ),
    SearchData(150, 324319, "Pitcher", "pitcher|glass|", "an/mobile-large/ME54_101_4.jpg", 0.67),
    SearchData(
        1600,
        451725,
        "\"The Concourse of the Birds\", Folio 11r from a Mantiq al-Tayr (Language of the Birds)",
        "folio from an illustrated manuscript|ink, opaque watercolor, gold, and silver on paper|codices",
        "is/mobile-large/DP234083.jpg",
        0.67
    ),
    SearchData(-900, 326249, "Bead", "bead|stone|", "an/mobile-large/ME1977_234_18.jpg", 1.03),
    SearchData(
        849,
        451514,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-17a.jpg",
        1.17
    ),
    SearchData(50, 324288, "Vessel", "vessel|ceramic|", "an/mobile-large/hb53_208.jpg", 0.40),
    SearchData(
        899,
        451580,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-87a.jpg",
        1.22
    ),
    SearchData(
        -1630,
        324556,
        "Scarab seal",
        "stamp seal|stone, white|",
        "an/mobile-large/ss56_152_2.jpg",
        1.43
    ),
    SearchData(150, 324318, "Vessel", "vessel|glass|", "an/mobile-large/ME54_101_3.jpg", 0.66),
    SearchData(-1500, 325124, "Axe head", "axe|bronze|", "an/mobile-large/ME61_73_1.jpg", 1.45),
    SearchData(
        849,
        451523,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-27b.jpg",
        1.30
    ),
    SearchData(
        50,
        325893,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_12.jpg",
        0.65
    ),
    SearchData(
        849,
        451519,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-22a.jpg",
        1.12
    ),
    SearchData(
        1330,
        448938,
        "\"The Funeral of Isfandiyar,\" Folio from a Shahnama (Book of Kings)",
        "folio from an illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP238058.jpg",
        0.73
    ),
    SearchData(
        -1981,
        552927,
        "Middle Kingdom statuette, reinscribed for Harsiese High Priest of Memphis in the Third Intermediate Period",
        "statuette, man, reinscribed for harsiese|greywacke|",
        "eg/mobile-large/LC-68_101_EGDP026382.jpg",
        0.67
    ),
    SearchData(
        1882,
        500567,
        "Rebab",
        "rebab|wood, leather, shells|chordophone-lute-bowed-unfretted",
        "mi/mobile-large/MUS2019.jpg",
        0.55
    ),
    SearchData(
        -1630,
        324564,
        "Scarab seal",
        "stamp seal|steatite, white|",
        "an/mobile-large/ss56_152_10.jpg",
        0.77
    ),
    SearchData(
        1049,
        451604,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-111a.jpg",
        0.85
    ),
    SearchData(
        1049,
        451598,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-105a.jpg",
        1.65
    ),
    SearchData(
        -1600,
        544669,
        "Canaanite Scarab with a Roaring Lion",
        "scarab, lion|steatite|",
        "eg/mobile-large/D_769_bottom.jpg",
        1.39
    ),
    SearchData(
        -1500,
        327792,
        "Cylinder seal",
        "cylinder seal|copper alloy (leaded bronze)|",
        "an/mobile-large/1999,325,196.jpg",
        5.56
    ),
    SearchData(
        1850,
        31572,
        "Dagger (Jambiya) with Sheath and Belt",
        "dagger (jambiya) with sheath and belt|steel, wood, silver, silver wire, textile, silk, leather|daggers",
        "aa/mobile-large/36.25.982ab_003july2014.jpg",
        0.56
    ),
    SearchData(-1900, 325342, "Oil lamp", "lamp|ceramic|", "an/mobile-large/ME61_150_1.jpg", 1.42),
    SearchData(
        150,
        324316,
        "Head-shaped flask",
        "flask|glass|",
        "an/mobile-large/ME54_101_1.jpg",
        0.68
    ),
    SearchData(
        1299,
        451587,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf60-23-94b.jpg",
        1.02
    ),
    SearchData(
        1299,
        451586,
        "Fragment",
        "fragment|porcelain|ceramics",
        "is/mobile-large/sf60-23-93a.jpg",
        1.13
    ),
    SearchData(
        -1300,
        322889,
        "Enthroned deity",
        "sculpture|bronze, gold foil|",
        "an/mobile-large/DP137934.jpg",
        0.70
    ),
    SearchData(
        -1966,
        545105,
        "Head of a sphinx, possibly of Amenemhat I",
        "head, sphinx; 12th-dyn-king|dolomitic marble|",
        "eg/mobile-large/66.99.4_EGDP017910.jpg",
        0.80
    ),
    SearchData(
        50,
        325912,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_31.jpg",
        0.62
    ),
    SearchData(
        1149,
        453615,
        "Basket Earring, One of a Pair",
        "earring|gold|jewelry",
        "is/mobile-large/35.29.5_6.jpg",
        1.03
    ),
    SearchData(
        849,
        451524,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-28a.jpg",
        1.47
    ),
    SearchData(
        849,
        455174,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-69a.jpg",
        1.55
    ),
    SearchData(
        1049,
        451597,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-104a.jpg",
        0.81
    ),
    SearchData(
        849,
        451545,
        "Fragment",
        "fragment|earthenware; slip painted, glazed|ceramics",
        "is/mobile-large/sf60-23-50a.jpg",
        1.59
    ),
    SearchData(
        1249,
        451551,
        "Fragment",
        "fragment|stonepaste; slip painted, incised, and splash glazed|ceramics",
        "is/mobile-large/sf60-23-56a.jpg",
        1.36
    ),
    SearchData(
        899,
        451534,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-38a.jpg",
        1.23
    ),
    SearchData(
        -700,
        326244,
        "Tridacna shell",
        "shell|shell (tridacna squamosa)|",
        "an/mobile-large/ME1977_234_13.jpg",
        1.46
    ),
    SearchData(-1500, 322524, "Pendant", "pendant|silver|", "an/mobile-large/me23_10_5.jpg", 1.09),
    SearchData(
        899,
        451575,
        "Fragment",
        "fragment|earthenware; incised|ceramics",
        "is/mobile-large/sf60-23-82a.jpg",
        1.49
    ),
    SearchData(
        1199,
        451512,
        "Fragment",
        "fragment|stonepaste; underglaze painted|ceramics",
        "is/mobile-large/sf60-23-15a.jpg",
        0.92
    ),
    SearchData(
        899,
        451536,
        "Fragment",
        "fragment|earthenware; painted decoration|ceramics",
        "is/mobile-large/sf60-23-40.jpg",
        1.20
    ),
    SearchData(
        1550,
        451092,
        "Safavid Courtiers Leading Georgian Captives",
        "panel|silk, metal wrapped thread; lampas|textiles-woven",
        "is/mobile-large/DP230052.jpg",
        0.56
    ),
    SearchData(
        1850,
        31573,
        "Dagger (Jambiya) with Sheath",
        "dagger (jambiya) with sheath|steel, wood, silver, gold, copper foil, pigment, paper, glue|daggers",
        "aa/mobile-large/36.25.983ab_003july2014.jpg",
        0.67
    ),
    SearchData(
        4,
        323749,
        "Stamp seal (scaraboid) with animals",
        "stamp seal|variegated red and neutral carnelian (quartz)|",
        "an/mobile-large/ss41_160_167.jpg",
        1.74
    ),
    SearchData(
        1738,
        446556,
        "Shahnama (Book of Kings) of Firdausi",
        "illustrated manuscript|ink, opaque watercolor, silver, and gold on paper|codices",
        "is/mobile-large/sf13-228-22-64r.jpg",
        0.59
    ),
    SearchData(
        899,
        451502,
        "Fragment",
        "fragment|earthenware; glazed|ceramics",
        "is/mobile-large/sf60-23-5a.jpg",
        0.86
    ),
    SearchData(
        1249,
        450578,
        "Dish with Horse and Rider",
        "dish|stonepaste; incised decoration through a black slip ground under a turquoise glaze (silhouette ware)|ceramics",
        "is/mobile-large/sf45-153-2b.jpg",
        1.00
    ),
    SearchData(
        -500,
        326422,
        "Stamp seal (duck-shaped) with geometric design",
        "stamp seal|stone|",
        "an/mobile-large/ss1986_311_5a.jpg",
        1.19
    ),
    SearchData(
        849,
        451525,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-29a.jpg",
        0.97
    ),
    SearchData(
        -1400,
        327231,
        "Smiting god, wearing an Egyptian atef crown",
        "sculpture|bronze|",
        "an/mobile-large/DP370818.jpg",
        0.70
    ),
    SearchData(-900, 326245, "Object", "object|stone|", "an/mobile-large/ME1977_234_14.jpg", 1.03),
    SearchData(
        50,
        325888,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_8.jpg",
        0.63
    ),
    SearchData(
        -450,
        324255,
        "Figure of ibex",
        "sculpture|bronze|",
        "an/mobile-large/IBEX.JPG",
        0.66
    ),
    SearchData(
        300,
        326693,
        "Head of a man",
        "sculpture|alabaster (gypsum)|",
        "an/mobile-large/DT6598.jpg",
        0.80
    ),
    SearchData(
        -550,
        323746,
        "Scarab seal",
        "stamp seal|jasper, green|",
        "an/mobile-large/ss41_160_164.jpg",
        0.87
    ),
    SearchData(
        1049,
        451600,
        "Fragment",
        "fragment|earthenware; incised and glazed|ceramics",
        "is/mobile-large/sf60-23-107a.jpg",
        1.50
    ),
    SearchData(50, 325898, "Vessel", "vessel|ceramic|", "an/mobile-large/ME67_246_17.jpg", 1.12),
    SearchData(
        -1594,
        556437,
        "Scarab with a Crocodile Headed Deity",
        "scarab, sebek|glazed steatite|",
        "eg/mobile-large/c_456_bottom.jpg",
        1.29
    ),
    SearchData(
        -550,
        323931,
        "Scaraboid seal",
        "stamp seal|serpentine, green|",
        "an/mobile-large/ss41_160_548.jpg",
        1.63
    ),
    SearchData(
        -1,
        322592,
        "Camel and riders",
        "sculpture|silver|",
        "an/mobile-large/DP-14352-001.jpg",
        0.77
    ),
    SearchData(
        -1630,
        324563,
        "Scarab seal",
        "stamp seal|stone, cream colored|",
        "an/mobile-large/ss56_152_9.jpg",
        0.87
    ),
    SearchData(50, 325904, "Juglet", "juglet|ceramic|", "an/mobile-large/ME67_246_23.jpg", 0.80),
    SearchData(
        899,
        451541,
        "Fragment",
        "fragment|earthenware; slip painted, incised, and splash glazed|ceramics",
        "is/mobile-large/sf60-23-45a.jpg",
        1.28
    ),
    SearchData(
        1199,
        451569,
        "Fragment",
        "fragment|stonepaste; slip painted and glazed|ceramics",
        "is/mobile-large/sf60-23-76a.jpg",
        1.41
    ),
    SearchData(
        1875,
        500985,
        "Stringed Instrument",
        "stringed instrument|wood|chordophone-lute-plucked-fretted",
        "mi/mobile-large/MUS251A.jpg",
        0.31
    ),
    SearchData(
        -1630,
        324557,
        "Scarab seal ring",
        "stamp seal ring|stone, white, copper alloy mount|",
        "an/mobile-large/ss56_152_3.jpg",
        0.56
    ),
    SearchData(
        -750,
        327024,
        "Stamp seal (scaraboid) with animal",
        "stamp seal|serpentine, black (?)|",
        "an/mobile-large/ss1984_383_63.jpg",
        1.16
    ),
    SearchData(
        -2500,
        327496,
        "Head of a bull",
        "sculpture|ivory (hippopotamus)|",
        "an/mobile-large/sd1994_81.jpg",
        0.84
    ),
    SearchData(
        -600,
        321452,
        "Stamp seal (grooved oval base with ribbed handle) with cultic scene",
        "stamp seal|neutral chalcedony (quartz)|",
        "an/mobile-large/ss74_51_4364.jpg",
        0.67
    ),
    SearchData(
        50,
        324244,
        "Fragment of painted ware",
        "sherd|ceramic, pigment|",
        "an/mobile-large/ME52_129_1.jpg",
        1.58
    ),
    SearchData(
        849,
        451517,
        "Fragment",
        "fragment|earthenware; molded decoration, glazed|ceramics",
        "is/mobile-large/sf60-23-20a.jpg",
        1.40
    ),
    SearchData(
        849,
        451546,
        "Fragment",
        "fragment|earthenware; slip painted, glazed|ceramics",
        "is/mobile-large/sf60-23-51a.jpg",
        1.53
    ),
    SearchData(
        -1648,
        556529,
        "Canaanite Scarab of the \"Anra\" Type",
        "scarab, \"anra\"|steatite|",
        "eg/mobile-large/30.8.896_bottom.jpg",
        0.78
    ),
    SearchData(
        1355,
        449537,
        "Mihrab (Prayer Niche)",
        "mihrab|mosaic of polychrome-glazed cut tiles on stonepaste body; set into mortar|ceramics",
        "is/mobile-large/DP235035.jpg",
        0.67
    ),
    SearchData(
        899,
        451593,
        "Fragment",
        "fragment|earthenware; splash glazed|ceramics",
        "is/mobile-large/sf60-23-100.jpg",
        1.52
    ),
    SearchData(
        -125,
        326694,
        "Votive or funerary stele",
        "stele|alabaster (gypsum)|",
        "an/mobile-large/DT959.jpg",
        0.78
    ),
    SearchData(
        50,
        325900,
        "Unguentarium",
        "vessel|ceramic|",
        "an/mobile-large/ME67_246_19.jpg",
        0.73
    ),
)